import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';

export const getCopilotRecommendationBannerStyles = makeStyles({
  toaster: {
    '& .fui-Toast': {
      backgroundColor: 'white',
      ...typographyStyles.body1Strong,
      boxShadow: tokens.shadow8,
      ...shorthands.border('1px', 'solid', 'transparent'),
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
    },
    '& .fui-ToastTitle__media': {
      color: 'green',
    },
    '& .close-button': {
      color: 'black',
    },
  },
});
